var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgThird = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0098EA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M21 28.53a7.53 7.53 0 1 0 0-15.06 7.53 7.53 0 0 0 0 15.06Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0098EA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M29.738 11.133c.397.366.774.742 1.13 1.13l4.282.611a16.191 16.191 0 0 1 1.6 3.86L34.146 20.2s.047 1.067 0 1.6l2.604 3.467c-.363 1.35-.9 2.648-1.6 3.859l-4.283.612s-.737.768-1.13 1.13l-.611 4.282a16.191 16.191 0 0 1-3.86 1.6L21.8 34.146a9.078 9.078 0 0 1-1.6 0l-3.467 2.604c-1.35-.363-2.648-.9-3.859-1.6l-.612-4.283a28.85 28.85 0 0 1-1.13-1.13l-4.282-.611a16.19 16.19 0 0 1-1.6-3.86L7.854 21.8s-.047-1.067 0-1.6L5.25 16.733c.363-1.35.9-2.648 1.6-3.859l4.283-.612a28.92 28.92 0 0 1 1.13-1.13l.611-4.282a16.19 16.19 0 0 1 3.86-1.6L20.2 7.854a9.083 9.083 0 0 1 1.6 0l3.467-2.604c1.35.363 2.648.9 3.859 1.6l.612 4.283Z"
})));
export default SvgThird;